import React from "react";

// Semi-circle gauge (e.g. Public Response Score "4.6 / 5.0 Excellent").
// Implemented as a plain SVG arc rather than a chart-library radial bar so
// the start/end caps and center label match the design exactly.
function describeArc(cx, cy, r, startAngle, endAngle) {
  const toXY = (angle) => {
    const rad = ((angle - 180) * Math.PI) / 180;
    return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
  };
  const start = toXY(startAngle);
  const end = toXY(endAngle);
  const largeArc = endAngle - startAngle <= 180 ? 0 : 1;
  return `M ${start.x} ${start.y} A ${r} ${r} 0 ${largeArc} 1 ${end.x} ${end.y}`;
}

// `inset` puts the value + "/max" inside the arc (Your Stats design) instead of below it.
export default function TspGauge({ value, max = 5, label, color = "#2FA96A", valueColor, size = 180, inset = false }) {
  const cx = size / 2;
  const cy = size / 2;
  const r = size / 2 - 14;
  const pct = Math.max(0, Math.min(1, value / max));

  return (
    <div className={`tsp-gauge ${inset ? "tsp-gauge-inset" : ""}`} style={{ width: size }}>
      <svg width={size} height={size / 2 + 20} viewBox={`0 0 ${size} ${size / 2 + 20}`}>
        <path d={describeArc(cx, cy, r, 0, 180)} fill="none" stroke="#EEF1F6" strokeWidth={14} strokeLinecap="round" />
        <path d={describeArc(cx, cy, r, 0, 180 * pct)} fill="none" stroke={color} strokeWidth={14} strokeLinecap="round" />
      </svg>
      <div className="tsp-gauge-value" style={{ color: valueColor || color }}>
        {value}
        <span className="tsp-gauge-max">/{max}.0</span>
      </div>
      {label && <div className="tsp-gauge-label" style={{ color }}>{label}</div>}
    </div>
  );
}
